import type { SettingsOptions } from '@oneview/types/settings';
import { createAction } from '@reduxjs/toolkit';

export const saveSettingsLocal = createAction<SettingsOptions>('SettingUpdateSettingsLocal');

export const setBackgroundPreference = createAction<string>('SetBackgroundPreference');
